import { ConfigTypeDto } from 'src/dtos';

export const configOptions = [
  { id: ConfigTypeDto.BANK_LINK, name: 'Bank Link Configuration' },
  { id: ConfigTypeDto.BANK_TRANSFER, name: 'Bank Transfer Configuration' },
];
